var React = require('react');

function RoundCrossBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 20.5C40 9.4543 31.0457 0.5 20 0.5C8.9543 0.5 0 9.4543 0 20.5C0 31.5457 8.9543 40.5 20 40.5C31.0457 40.5 40 31.5457 40 20.5ZM23.1427 20.5L29.4281 14.2146L26.2854 11.0719L20 17.3573L13.7146 11.0719L10.5719 14.2146L16.8573 20.5L10.5719 26.7854L13.7146 29.9281L20 23.6427L26.2854 29.9281L29.4281 26.7854L23.1427 20.5Z","fill":"#B13024"}));
}

RoundCrossBig.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = RoundCrossBig;

RoundCrossBig.default = RoundCrossBig;
